import { atom } from "jotai";

export const helpAtom = atom<{
  showHelpModal: boolean;
  created?: boolean;
}>({
  showHelpModal: false,
  created: false,
});
